import { useSupportCategories } from 'domains/support-section/hooks';
import { SupportUi } from './ui';

export const Support = () => {
  const { isLoading } = useSupportCategories();

  if (isLoading) return <SupportUi loading />;

  return <SupportUi />;
};
